import React from 'react';
import Spinner from './Spinner';

const PdfSpinner = () => <Spinner>Préparation du document...</Spinner>;

export default PdfSpinner;
